import React, { Component } from 'react'
import { mixUrl, cookiesName, stringJsonItem } from 'multiPublic/index'
import loadable from '@loadable/component'
import Cookies from 'js-cookie'
import { getImportantFlash } from '../redux/actions/flash'
import { getNewsDetails } from '../redux/actions/news'
// import icon from '../../static/resource/images/huoxing24.png'

const DetalShare = loadable(() => import('../containers-m/DetailShare'))

export default class DetailSharePage extends Component {
    static async getInitialProps (context) {
        const { match, store, res, req, isServer, history } = context
        const newsId = match.params.newsId
        if (!newsId) {
            isServer ? res.redirect('/') : history.push('/')
            return { customRes: true }
        }
        // 获取passportId, token
        const passportId = isServer ? req.cookies[cookiesName.passportId] : Cookies.get(cookiesName.passportId)
        const token = isServer ? req.cookies[cookiesName.token] : Cookies.get(cookiesName.token)
        let params = { id: newsId, req: req }
        if (passportId) {
            params = {
                id: newsId,
                passportId: passportId,
                token: token,
                req: req
            }
        }
        let returnData = {
            clientLink: mixUrl.news(`/${match.params.newsId}.html`, req),
            title: '',
            description: '',
            keywords: '',
            ogType: 'article',
            publishedTime: '',
            author: '',
            shareImage: ''
        }
        await Promise.all([
            store.dispatch(getNewsDetails(params)),
            store.dispatch(getImportantFlash({
                tags: 2,
                currentPage: 1,
                pageSize: 6,
                req: req
            }))
        ]).then(function (response) {
            const resDetails = response[0]
            if (resDetails.code === 1) {
                const details = resDetails.obj.current
                const synopsis = details.synopsis ? details.synopsis.replace(/^【GPT】\s*/, '') : ''
                returnData.title = details.title
                returnData.description = `${synopsis}来源于火星财经专栏作家${details.author}`
                returnData.keywords = details.tags
                returnData.publishedTime = details.publishTime
                returnData.author = details.author
                returnData.shareImage = stringJsonItem(details.coverPic, 'pc')
            }
            // 未查询到记录跳转到404页面
            if (resDetails.code === -1) {
                res.render('error', {
                    message: resDetails.msg || '新闻详情查询错误',
                    error: {
                        status: 200,
                        stack: JSON.stringify(resDetails)
                    }
                })
                returnData = { customRes: true }
            }
        }).catch(function (err) {
            throw new Error(err)
        })
        return returnData
    }

    render () {
        return <DetalShare {...this.props} />
    }
}
